import React, { useRef } from "react";

import ActiveIngredients from "./active-ingredients";
import Directions from "./directions";
import Footnotes from "./footnotes";
import Uses from "./uses";
import Warnings from "./warnings";
import withSpellcheck from "../../../../form-inputs/shared/spell-check";

import { Input, InputList, Textarea } from "../../../../form-inputs/inputs";
import { AsyncTypeahead } from "../../../../form-inputs/typeahead";

import { noteMarkList } from "../../nutritionpanel/lib/constants";

const SpellCheckInputList = withSpellcheck(InputList);

const DrugPanel = (props) => {
    const panelRef = useRef();
    const panel = props.panel;

    return (
        <div
            ref={panelRef}
            className="drug-facts"
        >
            <div className="panel">
                <div className="button-group">
                    <h2>
                        Drug Facts{" "}
                        <button
                            className="button -text -small"
                            onClick={props.removePanel}
                        >
                            Delete Panel
                        </button>
                    </h2>
                </div>
                <h3>Active Ingredients</h3>
                <Input
                    label="Serving Text"
                    name="servingText"
                    value={panel.servingText}
                    updateOnChange={props.updateState}
                />
                <ActiveIngredients
                    data={panel.activeIngredients}
                    addItem={props.addNewItem}
                    noteMarkList={noteMarkList}
                    removeItem={props.removeItem}
                    updateOnChange={props.updateItem}
                />
                <Footnotes
                    data={panel.footnotes}
                    noteMarkList={noteMarkList}
                    updateOnChange={props.updateState}
                />
                <hr />
                <Uses
                    data={panel.uses}
                    addItem={props.addNewItem}
                    removeItem={props.removeItem}
                    updateOnChange={props.updateItem}
                />
                <hr />
                <Warnings
                    data={panel.warnings}
                    addItem={props.addNewItem}
                    removeItem={props.removeItem}
                    updateOnChange={props.updateItem}
                />
                <hr />
                <Directions
                    directions={panel.directions}
                    userGroups={panel.userGroups}
                    addItem={props.addNewItem}
                    removeItem={props.removeItem}
                    updateOnChange={props.updateState}
                    updateItem={props.updateItem}
                />
                <hr />
                <SpellCheckInputList
                    name="otherInformation"
                    label="Other Information"
                    defaultValue={panel.otherInformation}
                    updateOnChange={props.updateState}
                    validation={{ type: "StringList" }}
                />
                <AsyncTypeahead
                    name="inactiveIngredients"
                    label="Inactive Ingredients"
                    provider="/picklists/drugInactiveIngredients/"
                    defaultValue={panel.inactiveIngredients}
                    updateOnChange={props.updateState}
                    multiple={true}
                    creatable={true}
                    draggable={true}
                />

                <Textarea
                    name="comments"
                    label="Questions/Comments Phone Number"
                    value={panel.comments}
                    updateOnChange={props.updateState}
                />
                <Textarea
                    name="additionalDetails"
                    label="Additional Product Detail"
                    value={panel.additionalDetails}
                    updateOnChange={props.updateState}
                />
            </div>
        </div>
    );
};

export default DrugPanel;
